import { DateInput, DateTimeInput, Field, NumericInput, TextOutput, TimeInput } from 'Components/Core';
import { DATETIME_INPUT_COLUMN_WIDTH, DateTimeStyle } from 'Components/Layout/Grid/types';
import { RecordGridField } from 'Components/Worksheets/Core';
import { DateTimeDataFormat } from 'Lib/Format';

export const getDryMassGridFieldSet = (
  dryMassEntryOption: any,
  dateTimeStyle: DateTimeStyle = DateTimeStyle.Separate
): Array<RecordGridField> => [
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Date Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Time Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateTimeInput />} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Separate,
    label: 'Date and Time Out of Oven',
    width: DATETIME_INPUT_COLUMN_WIDTH,
  },
  {
    name: 'DryingTime',
    component: <Field input={<TextOutput />} />,
    hidden: dryMassEntryOption === 'Never',
  },
  {
    name: 'DrySoilAndContainerMass',
    // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
    additionalMessagePaths: ['DrySoilMass'],
    component: <Field input={<NumericInput />} />,
    label: 'Tare & Dry Mass (g)', // shortened
  },
];
